import { render, staticRenderFns } from "./PuzzleTemplateCreate.vue?vue&type=template&id=0fc9b99f&"
import script from "./PuzzleTemplateCreate.vue?vue&type=script&lang=js&"
export * from "./PuzzleTemplateCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports